<div class="dob-container">
  <div class="ops-input-container" [class.disabled]="isDisabled">
    <label *ngIf="label" for="{{ formName }}" class="ops-input-label">
      {{ label }} <span *ngIf="mandatory">*</span>
    </label>
    <input
      *ngIf="!isPreview"
      (focus)="onFocus($event)"
      readonly
      [disabled]="isDisabled"
      [class.clickable]="!isDisabled"
      id="{{ formName }}"
      [placeholder]="'labels.dateFormat' | translate"
      (blur)="onBlur()"
      (click)="onClick($event)"
      [value]="date | date : 'dd.MM.yyyy'"
      (mousedown)="onMouseDown($event)"
      (mouseup)="onMouseUp($event)"
      (keydown)="onKeydown($event)"
      class="ops-input"
    />

    <span *ngIf="noteText && !isPreview" class="ops-input-note">{{
      noteText
    }}</span>
    <div *ngIf="isPreview" class="ops-input preview">
      <span>{{ date | date : 'dd.MM.yyyy' }}</span>
    </div>
  </div>

  <button
    (keydown)="onKeyDown($event)"
    class="button-calendar"
    [class.preview]="isPreview"
    [class.disabled]="isPreview || isDisabled"
    [disabled]="isPreview || isDisabled"
    tabindex="-1"
    *ngIf="!isHideIcon"
    (click)="openDatePicker()"
  >
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="22"
      height="23"
      viewBox="0 0 22 23"
    >
      <path
        d="M0,23H22V2H19V0H17V5.908H16V2H6V0H4V5.908H3V2H0ZM16,12.908v-2h2v2Zm2,1v2H16v-2Zm-5,2v-2h2v2Zm2,1v2H13v-2Zm-2-4v-2h2v2Zm-3,3v-2h2v2Zm2,1v2H10v-2Zm-2-4v-2h2v2Zm-3,3v-2H9v2Zm2,1v2H7v-2Zm-2-4v-2H9v2Zm-3,3v-2H6v2Zm2,1v2H4v-2Z"
      />
    </svg>
  </button>

  <ops-date-picker
    [invertDirection]="invertDirection"
    *ngIf="isOpen"
    [isOpen]="true"
    [minDate]="minDate"
    [maxDate]="maxDate"
    [startingFocusIndex]="100"
    [selectedDates]="selectedDates"
    (pickerClosed)="onDatePickerClosed($event)"
    (datesSelected)="onTogglePreparationDate($event)"
  ></ops-date-picker>
</div>
